import { render } from "./Header.vue?vue&type=template&id=3d8685ac&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=3d8685ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d8685ac"

export default script